export default "__VITE_ASSET__CEvPYior__"